import { render, staticRenderFns } from "./LinkRedirectWarning.vue?vue&type=template&id=65dd2a85&scoped=true"
import script from "./LinkRedirectWarning.vue?vue&type=script&lang=js"
export * from "./LinkRedirectWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dd2a85",
  null
  
)

export default component.exports